import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/assets/css/index.css'
import App from '@/App'

async function enableMocking() {
  if (process.env.REACT_APP_ENABLE_MOCK !== 'true') return
  const { worker } = await import('@/mocks/browser')
  return worker.start({
    onUnhandledRequest: 'warn',
    serviceWorker: { url: '/mockServiceWorker.js' },
  })
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(<App />)

  const loading = document.getElementById('global-loading')
  if (loading) loading.remove()
})
